'use strict';

export const VALID_PREDEFINED_TIMING_FUNCTIONS = ['linear', 'ease', 'ease-in', 'ease-out', 'ease-in-out', 'step-start', 'step-end'];
export const VALID_PARAMETRIZED_TIMING_FUNCTIONS = ['cubic-bezier', 'steps', 'linear'];
//# sourceMappingURL=settings.js.map